import LegacyAnalyticsContext from './LegacyAnalyticsContext';
import ModernAnalyticsContext from './ModernAnalyticsContext';
var ExportedAnalyticsContext;
if (process.env['ANALYTICS_NEXT_MODERN_CONTEXT']) {
    ExportedAnalyticsContext = ModernAnalyticsContext;
}
else {
    ExportedAnalyticsContext = LegacyAnalyticsContext;
}
export default ExportedAnalyticsContext;
//# sourceMappingURL=index.js.map